// import React from "react";

// const teamMembers = [
//   {
//     name: "Mrugank Karandikar",
//     role: "Founder",
//     image: "Photos/john_doe.jpeg",
//     description:
//       "Mrugank, as the Founder  of Brandflow, is the driving force behind the company’s inception and growth. As the first point of contact, he ensures smooth communication with clients, visitors, and stakeholders while representing Brandflow’s vision and values. Mrugank’s hands-on approach in managing inquiries and fostering relationships reflects his dedication to creating a professional and welcoming environment. As the founder, he embodies the spirit of innovation and leadership, laying the foundation for Brandflow’s success in empowering startups.",
//   },
//   {
//     name: "Mansi",
//     role: "Co-Founder",
//     image: "Photos/jane_smith.jpeg",
//     description:
//       "Mansi, as the Co-Founder of Brandflow, is a visionary leader who combines financial expertise with entrepreneurial spirit. She oversees the company’s financial planning, budgeting, and sustainability while playing a central role in shaping Brandflow’s strategic direction. As a co-founder, Mansi brings a deep understanding of the company’s mission and values, ensuring that every financial decision aligns with Brandflow’s vision of empowering startups. Her leadership and dedication are instrumental in driving both financial stability and long-term growth for the company.",
//   },
//   {
//     name: "Kavya Patel",
//     role: "Chief Technology Officer (CTO)",
//     image: "Photos/david_wilson.jpeg",
//     description:
//       "Kavya, as the Chief Technology Officer (CTO) of Brandflow, is the driving force behind the company’s technological innovation and strategy. He ensures that the latest tools and technologies are implemented to optimize Brandflow’s digital marketing and social media services. Kavya leads the tech team with a vision to create scalable, efficient, and cutting-edge solutions that empower startups to thrive in Mumbai's competitive environment. His expertise in tech-enabled growth strategies makes him a vital pillar of Brandflow's success.",
//   },
//   {
//     name: "Divasha",
//     role: "Human Resources (HR) Director",
//     image: "Formal Photos/divasha.jpeg",
//     description:
//       "Divasha, as the Human Resources Director of Brandflow, is the cornerstone of the company’s people management and organizational culture. She oversees recruitment, employee engagement, and talent development, ensuring that Brandflow attracts and retains the best minds in the industry. With a focus on creating a collaborative and inclusive workplace, Divasha fosters a culture of innovation and growth, empowering the team to deliver their best. Her leadership ensures that Brandflow remains a people-centric organization, driving success through its talented workforce.",
//   },
// ];

// function TeamSection() {
//   return (
//     <div className="bg-black py-12">
//       <div className="max-w-6xl mx-auto px-4 text-center">
//         <h2 className="text-4xl font-bold text-gray-300 mb-10">
//           Meet Our Team
//         </h2>
//         <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
//           {teamMembers.map((member, index) => (
//             <div key={index} className="bg-white rounded-lg shadow-lg p-6">
//               <img
//                 src={member.image}
//                 alt={member.name}
//                 className="w-full h-64 object-cover rounded-lg mb-4"
//               />
//               <h3 className="text-xl font-semibold text-gray-800">
//                 {member.name}
//               </h3>
//               <p className="text-gray-500 text-sm">{member.role}</p>
//               <p className="text-gray-600 mt-2">{member.description}</p>
//             </div>
//           ))}
//         </div>
//       </div>
//     </div>
//   );
// }

// export default TeamSection;

// import React from "react";

// const teamMembers = [
//   {
//     name: "Mrugank Karandikar",
//     role: "Founder",
//     image: "Formal Photos/Mrugank.jpeg",
//     description:
//       "Mrugank, as the Founder of Brandflow, is the driving force behind the company’s inception and growth. As the first point of contact, he ensures smooth communication with clients, visitors, and stakeholders while representing Brandflow’s vision and values. Mrugank’s hands-on approach in managing inquiries and fostering relationships reflects his dedication to creating a professional and welcoming environment. As the founder, he embodies the spirit of innovation and leadership, laying the foundation for Brandflow’s success in empowering startups.",
//   },
//   {
//     name: "Mansi Nathwani",
//     role: "Co-Founder",
//     image: "Formal Photos/Mansi.jpeg",
//     description:
//       "Mansi, as the Co-Founder of Brandflow, is a visionary leader who combines financial expertise with entrepreneurial spirit. She oversees the company’s financial planning, budgeting, and sustainability while playing a central role in shaping Brandflow’s strategic direction. As a co-founder, Mansi brings a deep understanding of the company’s mission and values, ensuring that every financial decision aligns with Brandflow’s vision of empowering startups. Her leadership and dedication are instrumental in driving both financial stability and long-term growth for the company.",
//   },
//   {
//     name: "Kavya Patel",
//     role: "Chief Technology Officer (CTO)",
//     image: "Formal Photos/Kavya Final.jpg",
//     description:
//       "Kavya, as the Chief Technology Officer (CTO) of Brandflow, is the driving force behind the company’s technological innovation and strategy. He ensures that the latest tools and technologies are implemented to optimize Brandflow’s digital marketing and social media services. Kavya leads the tech team with a vision to create scalable, efficient, and cutting-edge solutions that empower startups to thrive in Mumbai's competitive environment. His expertise in tech-enabled growth strategies makes him a vital pillar of Brandflow's success.",
//   },
//   {
//     name: "Divasha Shahu",
//     role: "Human Resources (HR) Director",
//     image: "Formal Photos/Divasha (1).jpeg",
//     description:
//       "Divasha, as the Human Resources Director of Brandflow, is the cornerstone of the company’s people management and organizational culture. She oversees recruitment, employee engagement, and talent development, ensuring that Brandflow attracts and retains the best minds in the industry. With a focus on creating a collaborative and inclusive workplace, Divasha fosters a culture of innovation and growth, empowering the team to deliver their best. Her leadership ensures that Brandflow remains a people-centric organization, driving success through its talented workforce.",
//   },
// ];

// function TeamSection() {
//   return (
//     <div className="bg-primary-color py-12">
//       <div className="max-w-6xl mx-auto px-4 text-center">
//         <h2 className="text-4xl font-bold text-gray-800 mb-10">
//           Meet Our Team
//         </h2>
//         <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
//           {teamMembers.map((member, index) => (
//             <div
//               key={index}
//               className="bg-primary-color rounded-lg shadow-2xl border border-gray-400 p-6 transition-transform transform hover:scale-105 hover:shadow-2xl"
//             >
//               <img
//                 src={member.image}
//                 alt={member.name}
//                 className="w-full h-64 object-cover rounded-lg mb-4"
//               />
//               <h3 className="text-xl font-semibold text-gray-800">
//                 {member.name}
//               </h3>
//               <p className="text-gray-700 text-sm">{member.role}</p>
//               <p className="text-gray-800 mt-2 text-balance">
//                 {member.description}
//               </p>
//             </div>
//           ))}
//         </div>
//       </div>
//     </div>
//   );
// }

// export default TeamSection;

import React from "react";

const teamMembers = [
  {
    name: "Mrugank Karandikar",
    role: "Founder",
    image: "Formal Photos/Mrugank.jpeg",
    description:
      "Mrugank, as the Founder of Brandflow, is the driving force behind the company’s inception and growth. As the first point of contact, he ensures smooth communication with clients, visitors, and stakeholders while representing Brandflow’s vision and values.",
  },
  {
    name: "Mansi Nathwani",
    role: "Co-Founder",
    image: "Formal Photos/Mansi.jpeg",
    description:
      "Mansi, as the Co-Founder of Brandflow, brings strong financial expertise and strategic leadership that guides Brandflow’s long-term direction, ensuring financial stability and scalable growth.",
  },
  {
    name: "Kavya Patel",
    role: "Chief Technology Officer (CTO)",
    image: "Formal Photos/Kavya Final.jpg",
    description:
      "Kavya, the CTO of Brandflow, leads the technological direction of the company, driving innovations that enhance digital marketing performance and deliver scalable tech-enabled solutions.",
  },
  {
    name: "Divasha Shahu",
    role: "Human Resources (HR) Director",
    image: "Formal Photos/Divasha (1).jpeg",
    description:
      "Divasha oversees people management and culture development at Brandflow, ensuring a cohesive, motivated, and high-performing team aligned with Brandflow’s mission.",
  },
];

function TeamSection() {
  return (
    <div className="relative bg-primary-color py-24 overflow-hidden">
      {/* Soft glowing background orbs */}
      <div className="absolute top-0 left-0 w-[500px] h-[500px] bg-secondary-color/55 rounded-full blur-[150px]"></div>
      <div className="absolute bottom-0 right-0 w-[500px] h-[500px] bg-secondary-color/55 rounded-full blur-[150px]"></div>

      <div className="relative max-w-7xl mx-auto px-6 z-10">
        {/* Section title */}
        <h2 className="text-center text-4xl sm:text-5xl md:text-6xl font-semibold tracking-tight text-highlight-color mb-16 drop-shadow-lg">
          Meet Our Team
        </h2>

        {/* Team grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-12">
          {teamMembers.map((member, index) => (
            <div
              key={index}
              className="group backdrop-blur-xl bg-secondary-color/25 border border-white/10 rounded-3xl p-8 shadow-2xl 
              hover:shadow-[0_0_25px_#9b81ff60] hover:-translate-y-2 transition-all duration-300"
            >
              {/* Circular Portrait */}
              <div className="w-40 h-40 mx-auto rounded-full overflow-hidden shadow-xl border border-white/10 group-hover:border-[rgb(100,64,246)] group-hover:border-4 transition-all duration-300">
                <img
                  src={member.image}
                  alt={member.name}
                  className="w-full h-full object-cover"
                />
              </div>

              {/* Name */}
              <h3 className="text-2xl font-semibold text-white mt-6 text-center">
                {member.name}
              </h3>

              {/* Role */}
              <p className="text-secondary-color text-center text-sm font-medium mt-1 tracking-wide">
                {member.role}
              </p>

              {/* Description */}
              <p className="text-white/70 text-center mt-4 leading-relaxed text-[15px]">
                {member.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default TeamSection;
